var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._g(_vm._b({ref:"input",class:{ plaintext: _vm.plaintext },attrs:{"type":_vm.type,"id":_vm.uuid,"disabled":_vm.plaintext || _vm.disabled},domProps:{"value":_vm.formattedValue},on:{"input":_vm.input}},'input',_vm.attrs,false),_vm.lisnters))
}
var staticRenderFns = []

export { render, staticRenderFns }